import { useContext, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";
import {
  AnecdotesModalContext,
  AnecdotesModalProvider,
} from "../../contexts/AnecdotesModalContext";
import { AudioProvider } from "../../contexts/AudioContext";
import { BookContext, BookProvider } from "../../contexts/BookContext";
import { selectUser } from "../../store/slices/auth";
import { useSelector } from "../../store/store";
import { AnecdotesModal } from "../AnecdotesModal";
import { Paywall } from "../Modals/Paywall";
import Breadcrumb from "./Breadcrumb";
import { Nav } from "./Nav";

const LayoutContent = () => {
  const { refresh } = useContext(BookContext);
  const {
    isOpen,
    chapterNumber,
    generatedChapterId,
    chapterTitle,
    closeModal,
  } = useContext(AnecdotesModalContext);
  const user = useSelector(selectUser);
  const hasAccess = user?.is_subscription_active;
  const [open, setOpen] = useState(true);
  const subscriptionURl = import.meta.env.VITE_MEMOIRS_SUBSCRIPTION_URL || "";
  const location = useLocation();

  useEffect(() => {
    const shouldRefresh =
      location.pathname.includes("/dashboard") ||
      location.pathname.includes("/chapter") ||
      location.pathname.includes("/question");

    if (!!user && shouldRefresh) {
      refresh();
    }
  }, [location.pathname, refresh, user]);

  return (
    <>
      <div className="fixed w-full top-0 z-10 bg-white border-b-2 border-delicate-50">
        <Nav />
        <div className="w-full mx-auto px-2 sm:px-6 lg:px-8 justify-start p-2 sm:p-4 bg-white border-t-2 border-delicate-50">
          <div className="flex justify-between">
            <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
              <Breadcrumb />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-1 bg-delicate-50 mt-20 sm:mt-24 lg:mt-28">
        {hasAccess ? (
          <Outlet />
        ) : (
          <Paywall
            open={open}
            setOpen={setOpen}
            subscriptionURl={subscriptionURl}
          />
        )}
      </div>
      {chapterNumber && (
        <AnecdotesModal
          isOpen={isOpen}
          onClose={closeModal}
          chapterNumber={chapterNumber}
          generatedChapterId={generatedChapterId}
          chapterTitle={chapterTitle}
        />
      )}
    </>
  );
};

export const Layout = () => {
  return (
    <BookProvider>
      <AudioProvider>
        <AnecdotesModalProvider>
          <LayoutContent />
        </AnecdotesModalProvider>
      </AudioProvider>
    </BookProvider>
  );
};
